import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
/**
 * Host-specific Configuration Loader
 *
 * This utility detects the current hostname and loads the appropriate configuration file
 * from the config.json.d directory. If no matching configuration is found, it falls back
 * to the default configuration.
 */

import JSON5 from 'json5';
import Logger from '@/libs/Logger';
var log = Logger.namespace('host-config-loader');

/**
 * Load the host-specific configuration
 * @param {Object} defaultConfig - The default configuration object
 * @returns {Promise<Object>} - The merged configuration object
 */
export function loadHostConfig(_x) {
  return _loadHostConfig.apply(this, arguments);
}

/**
 * Load the host-specific configuration from a script tag
 * @param {Object} defaultConfig - The default configuration object
 * @returns {Object} - The merged configuration object
 */
function _loadHostConfig() {
  _loadHostConfig = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(defaultConfig) {
    var _context;
    var hostname, fullPath, normalizedPath, baseUrl, pathParts, _context2, configUrl, response, hostConfig, _context3, fallbackUrl, fallbackResponse, fallbackConfig, _t, _t2;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          hostname = window.location.hostname;
          log.info("Detected hostname: ".concat(hostname));

          // Determine the base path for static resources
          // Get the full path without the hostname and protocol
          fullPath = window.location.pathname; // Remove trailing slash if present
          normalizedPath = _endsWithInstanceProperty(fullPath).call(fullPath, '/') ? _sliceInstanceProperty(fullPath).call(fullPath, 0, -1) : fullPath; // Extract the application root path (e.g., /relayos-kiwiirc/)
          // This assumes the application is always mounted at a path like /relayos-kiwiirc/
          // and not at the root of the domain
          baseUrl = '/'; // Check if we're in a path that starts with /relayos-kiwiirc/
          if (_includesInstanceProperty(normalizedPath).call(normalizedPath, '/relayos-kiwiirc')) {
            baseUrl = '/relayos-kiwiirc/';
            log.info("Using fixed application root path: ".concat(baseUrl));
          } else {
            // For other cases, extract the first path segment
            pathParts = normalizedPath.split('/');
            if (pathParts.length > 1 && pathParts[1]) {
              baseUrl = '/' + pathParts[1] + '/';
              log.info("Using detected application root path: ".concat(baseUrl));
            }
          }

          // Log the detected base URL for debugging
          log.info(_concatInstanceProperty(_context = "Using base URL: ".concat(baseUrl, " (original path: ")).call(_context, normalizedPath, ")"));
          _context4.prev = 1;
          // Try to load the host-specific configuration from the directory structure
          configUrl = _concatInstanceProperty(_context2 = "".concat(baseUrl, "config.json.d/")).call(_context2, hostname, "/config.json");
          log.info("Fetching config from: ".concat(configUrl));
          _context4.next = 2;
          return fetch(configUrl);
        case 2:
          response = _context4.sent;
          if (!response.ok) {
            _context4.next = 4;
            break;
          }
          _context4.next = 3;
          return response.json();
        case 3:
          hostConfig = _context4.sent;
          log.info("Loaded host-specific configuration for ".concat(hostname));

          // Add the base path to the configuration
          if (baseUrl && !hostConfig.baseUrl) {
            hostConfig.baseUrl = baseUrl;
          }

          // Return the host-specific configuration directly without merging
          return _context4.abrupt("return", hostConfig);
        case 4:
          log.info("No host-specific configuration found for ".concat(hostname, ", trying fallback"));

          // Try the old-style flat file as a fallback
          _context4.prev = 5;
          fallbackUrl = _concatInstanceProperty(_context3 = "".concat(baseUrl, "config.json.d/")).call(_context3, hostname, ".json");
          log.info("Fetching config from: ".concat(fallbackUrl));
          _context4.next = 6;
          return fetch(fallbackUrl);
        case 6:
          fallbackResponse = _context4.sent;
          if (!fallbackResponse.ok) {
            _context4.next = 8;
            break;
          }
          _context4.next = 7;
          return fallbackResponse.json();
        case 7:
          fallbackConfig = _context4.sent;
          log.info("Loaded fallback configuration for ".concat(hostname));

          // Add the base path to the configuration
          if (baseUrl && !fallbackConfig.baseUrl) {
            fallbackConfig.baseUrl = baseUrl;
          }
          return _context4.abrupt("return", fallbackConfig);
        case 8:
          log.info("No fallback configuration found for ".concat(hostname, ", trying default config"));
          return _context4.abrupt("return", loadDefaultConfig(defaultConfig, baseUrl));
        case 9:
          _context4.next = 11;
          break;
        case 10:
          _context4.prev = 10;
          _t = _context4["catch"](5);
          log.info("No fallback configuration found for ".concat(hostname, ", trying default config"));
          return _context4.abrupt("return", loadDefaultConfig(defaultConfig, baseUrl));
        case 11:
          _context4.next = 13;
          break;
        case 12:
          _context4.prev = 12;
          _t2 = _context4["catch"](1);
          log.error("Error loading host-specific configuration: ".concat(_t2.message));
          log.info('Trying default config due to error');
          return _context4.abrupt("return", loadDefaultConfig(defaultConfig, baseUrl));
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee, null, [[1, 12], [5, 10]]);
  }));
  return _loadHostConfig.apply(this, arguments);
}
export function loadHostConfigFromScript(defaultConfig) {
  var hostname = window.location.hostname;
  log.info("Detected hostname: ".concat(hostname));

  // Look for a script tag with the host-specific configuration
  var scriptTag = document.querySelector("script[name=\"kiwiconfig-".concat(hostname, "\"]"));
  if (scriptTag) {
    try {
      var hostConfig = JSON5.parse(scriptTag.innerHTML);
      log.info("Loaded host-specific configuration for ".concat(hostname, " from script tag"));

      // Return the host-specific configuration directly without merging
      return hostConfig;
    } catch (error) {
      log.error("Error parsing host-specific configuration from script tag: ".concat(error.message));
      log.info('Trying default config due to script tag error');
      return loadDefaultConfig(defaultConfig);
    }
  } else {
    log.info("No host-specific configuration found for ".concat(hostname, " in script tags, trying default config"));
    return loadDefaultConfig(defaultConfig);
  }
}

/**
 * Load the default configuration
 * @param {Object} defaultConfig - The default configuration object
 * @param {string} baseUrl - The base URL path
 * @returns {Promise<Object>} - The merged configuration object
 */
function loadDefaultConfig(_x2) {
  return _loadDefaultConfig.apply(this, arguments);
}
function _loadDefaultConfig() {
  _loadDefaultConfig = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(defaultConfig) {
    var baseUrl,
      defaultConfigUrl,
      response,
      defaultHostConfig,
      configCopy,
      _configCopy,
      _args2 = arguments,
      _t3;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          baseUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
          _context5.prev = 1;
          // Try to load the default configuration
          defaultConfigUrl = "".concat(baseUrl, "config.json.d/default/config.json");
          log.info("Fetching config from: ".concat(defaultConfigUrl));
          _context5.next = 2;
          return fetch(defaultConfigUrl);
        case 2:
          response = _context5.sent;
          if (!response.ok) {
            _context5.next = 4;
            break;
          }
          _context5.next = 3;
          return response.json();
        case 3:
          defaultHostConfig = _context5.sent;
          log.info('Loaded default configuration');

          // Add the base path to the configuration
          if (baseUrl && !defaultHostConfig.baseUrl) {
            defaultHostConfig.baseUrl = baseUrl;
          }

          // Return the default host configuration directly without merging
          return _context5.abrupt("return", defaultHostConfig);
        case 4:
          log.info('No default configuration found, using provided default');

          // Add the base path to the default configuration
          if (!(baseUrl && !defaultConfig.baseUrl)) {
            _context5.next = 5;
            break;
          }
          configCopy = JSON.parse(_JSON$stringify(defaultConfig));
          configCopy.baseUrl = baseUrl;
          return _context5.abrupt("return", configCopy);
        case 5:
          return _context5.abrupt("return", defaultConfig);
        case 6:
          _context5.next = 9;
          break;
        case 7:
          _context5.prev = 7;
          _t3 = _context5["catch"](1);
          log.error("Error loading default configuration: ".concat(_t3.message));

          // Add the base path to the default configuration
          if (!(baseUrl && !defaultConfig.baseUrl)) {
            _context5.next = 8;
            break;
          }
          _configCopy = JSON.parse(_JSON$stringify(defaultConfig));
          _configCopy.baseUrl = baseUrl;
          return _context5.abrupt("return", _configCopy);
        case 8:
          return _context5.abrupt("return", defaultConfig);
        case 9:
        case "end":
          return _context5.stop();
      }
    }, _callee2, null, [[1, 7]]);
  }));
  return _loadDefaultConfig.apply(this, arguments);
}
export default {
  loadHostConfig: loadHostConfig,
  loadHostConfigFromScript: loadHostConfigFromScript,
  loadDefaultConfig: loadDefaultConfig
};